import React, { Component, Fragment } from 'react';
import ReactDOM from 'react-dom';
import CompareCta from './compare_cta';
import CompareModal from './compare_modal';

export default class CompareListings extends Component {
  constructor(props) {
    super(props);

    const modalPortal = document.createElement('div');
    this.modalPortal = document.body.appendChild(modalPortal);

    this.state = {
      showCompareModal: false,
      scrollYPosition: 0,
    };
  }

  componentWillUnmount() {
    document.body.removeChild(this.modalPortal);
  }

  render() {
    if (!this.props.enableCompareFeature) {
      return null;
    }

    return (
      <Fragment>
        <CompareCta
          active={this.props.compareListings.length > 1}
          handleCtaClick={this.handleOpenModal}
          btnText="Compare "
          propertiesSelected={this.props.compareListings.length}
          showCount={this.props.showCount}
          hideOnMobile={this.props.hideOnMobile}
          hideOnDesktop={this.props.hideOnDesktop}
        />
        {this.state.showCompareModal &&
          ReactDOM.createPortal(
            <CompareModal comparedListings={this.props.compareListings} handleCloseModal={this.handleCloseModal} />,
            this.modalPortal
          )}
      </Fragment>
    );
  }

  handleOpenModal = () => {
    if (this.props.compareListings.length > 1) {
      this.setState(
        {
          showCompareModal: !this.state.showCompareModal,
          scrollYPosition: window.scrollY,
        },
        () => {
          document.body.classList.toggle('modal-open');
          document.body.style.top = `-${this.state.scrollYPosition}px`;

          track_event('compare_listing', 'clicked', 'compare_listing', this.props.compareListings.length);
        }
      );
    }
  };

  handleCloseModal = () => {
    document.body.classList.toggle('modal-open');
    window.scrollTo({
      top: this.state.scrollYPosition,
      left: 0,
    });
    this.setState({
      showCompareModal: false,
    });
  };
}
